import { useLazyFetchWorkoutQuery, useCreateWorkoutExerciseMutation, useCreateSetObjectiveMutation, useCreateWorkoutMutation } from "../store";

export const useWorkoutService = () => {
  const [getWorkout] = useLazyFetchWorkoutQuery();
  const [createWorkout] = useCreateWorkoutMutation();
  const [createWorkoutExercise] = useCreateWorkoutExerciseMutation();
  const [createSetObjective] = useCreateSetObjectiveMutation();

  const handleDuplicate = async (workoutId, refetch) => {
    try {
      const { data, error } = await getWorkout(workoutId);
      if (error) {
        console.error('Error al obtener el workout duplicado:', error);
        return;
      }

      // Crear copia del workout
      const workout = data[0];
      const { data: createdWorkoutArray } = await createWorkout({
        name: workout.name + '-Copy',
        coach: workout.coach,
      });
      const createdWorkout = createdWorkoutArray[0];

      // Crear copia de cada ejercicio del workout (en paralelo por independencia)
      await Promise.all(
        workout.workout_exercise.map(async (workout_exercise) => {
          const { data: createdWorkoutExerciseArray } = await createWorkoutExercise({
            workout: createdWorkout.id,
            exercise: workout_exercise.exercise.id,
            order: workout_exercise.order,
            note: workout_exercise.note,
            superset: workout_exercise.superset,
          });
          const createdWorkoutExercise = createdWorkoutExerciseArray[0];

          // Crear copia de cada set objetivo del ejercicio (en paralelo)
          await Promise.all(
            workout_exercise.set_objective.map((set) =>
              createSetObjective({
                workout_exercise: createdWorkoutExercise.id,
                index: set.index,
                kg: set.kg,
                reps: set.reps,
                rpe: set.rpe,
                rir: set.rir,
                tut: set.tut,
                time: set.time,
                rest: set.rest,
                percentage_rm: set.percentage_rm,
                note: set.note,
              })
            )
          );
        })
      );

      refetch();
    } catch (error) {
      console.error('Error al duplicar el workout:', error);
    }
  };

  return {
    handleDuplicate,
  };
};
